module.exports = __webpack_public_path__ + "img/angela-sung-car.2c8bedf.jpg";